function isDomElement(object) {
  return object instanceof HTMLElement || Boolean(object) && object.nodeType > 0;
}

export default isDomElement;


// WEBPACK FOOTER //
// ../node_modules/instantsearch.js/es/lib/utils/isDomElement.js